import React, { memo } from 'react'
import { format } from 'date-fns'
import { Map } from 'immutable'

const Slot = memo(({ slot, value, onChange, branchId, selectBranch }) => {
  if (!slot.available) return null
  const startTime = format(slot.start, 'HH.mm')
  const endTime = format(slot.end, 'HH.mm')
  const id = `${startTime}-${endTime}`
  const checked =
    (value && value.get('start') === slot.start.toISOString() && value.get('end') === slot.end.toISOString()) || false
  const onChangeHandler = (_event) => {
    onChange(Map({ start: slot.start.toISOString(), end: slot.end.toISOString(), available: true }))
    if (branchId) selectBranch(branchId)
  }
  return (
    <li className="atp-time-list__entry">
      <input
        id={id}
        type="radio"
        name="timeslots"
        className="atp-time-list__radio"
        tabIndex="0"
        checked={checked}
        onChange={onChangeHandler}
      />
      <label htmlFor={id} className="atp-time-list__label">
        <span className="atp-time-list__timeslot">
          {startTime} – {endTime}
        </span>
        {slot.name && <span className="atp-time-list__location">{slot.name}</span>}
      </label>
    </li>
  )
})
Slot.displayName = 'Slot'

export default Slot
